// components/Layout.js

import Whatsappbutton from "../pages/whatsappbutton";




const Layout1 = ({ children}) => {
  return (
    <div className="relative min-h-screen ">
      {children}
      <Whatsappbutton />
    </div>
  );
};
// 2xl:px-48
export default Layout1;
